import { render, staticRenderFns } from "./ws-fed.vue?vue&type=template&id=445b0ec2&scoped=true&"
import script from "./ws-fed.vue?vue&type=script&lang=js&"
export * from "./ws-fed.vue?vue&type=script&lang=js&"
import style0 from "./ws-fed.vue?vue&type=style&index=0&id=445b0ec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b0ec2",
  null
  
)

export default component.exports